import React, { useState } from "react";

const PLACEHOLDER =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><rect width='100%' height='100%' fill='%23efe9dd'/><g fill='%23C9A66B'><circle cx='200' cy='170' r='60' fill='none' stroke='%23C9A66B' stroke-width='6'/><text x='50%' y='300' font-family='serif' font-size='34' text-anchor='middle'>Mayuresh</text></g></svg>`
  );

// Graceful image with fallback placeholder for broken/missing dish images.
export default function DishImage({ src, alt, className }) {
  const [err, setErr] = useState(false);
  return (
    <img
      src={err || !src ? PLACEHOLDER : src}
      alt={alt}
      loading="lazy"
      onError={() => setErr(true)}
      className={className}
    />
  );
}
